// Angular
import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
// services
import { TranslatorService } from 'src/app/services';

@Component({
    selector: 'app-field-single-check',
    templateUrl: './field-single-check.component.html',
    styleUrls: ['./field-single-check.component.scss'],
    standalone: false
})
export class FieldSingleCheckComponent {
    @Input() model: boolean;
    @Input() title1: string;
    @Input() title2: string;
    @Input() title3: string;
    @Input() title4: string;
    @Input() height: string = '40px';
    @Output() modelChange = new EventEmitter();

    constructor(private translateService: TranslatorService) {}

    check() {
        if (this.model) {
            this.modelChange.emit(false);
        } else this.modelChange.emit(true);
    }

    routeToTermsOfUse(event) {
        event.preventDefault();
        this.translateService.getLanguage().subscribe((language) => {
            window.open(`/${language}/terms-of-use`, '_blank');
        });
    }

    routeToPrivacyPolicy(event) {
        event.preventDefault();
        this.translateService.getLanguage().subscribe((language) => {
            window.open(`/${language}/privacy-policy`, '_blank');
        });
    }
}
